import { TradePosition } from '@sportspredict/shared';

export function useMarketOddsMath(market: any, selectedPosition: any) {
	const calculateMaxValues = () => {
		const currentValue = market.current_value;

		if (selectedPosition === TradePosition.Long) {
			return {
				maxProfit: 100 - currentValue,
				maxLoss: currentValue,
			};
		} else {
			return {
				maxProfit: currentValue,
				maxLoss: 100 - currentValue,
			};
		}
	};

	const calculatePotentialValues = (pos: any, value: any) => {
		const currentValue = value;
		if (pos === TradePosition.Long) {
			return {
				maxProfit: 100 - currentValue,
				maxLoss: currentValue,
			};
		} else {
			return {
				maxProfit: currentValue,
				maxLoss: 100 - currentValue,
			};
		}
	};

	return { calculateMaxValues, calculatePotentialValues };
}
